import React, {useEffect, useState} from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Button,
} from '@material-ui/core';

import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

import { useHistory } from 'react-router-dom';

import { CreateCompany } from './CreateCompany'

import majors from './majors';
import { getCompaniesAPIReq, postOfferAPIReq } from 'utils/requests'
import validate from "validate.js";
import {makeStyles} from "@material-ui/styles";
import moment from "moment";

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';


const filter = createFilterOptions();

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
}));

export default function FormDialog() {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(null);
  const [companies, setCompanies] = React.useState([]);
  const [company, setCompany] = React.useState();
  const [school, setSchool] = React.useState('SBA');
  const [description, setDescription] = React.useState(null);
  const [major, setMajor] = React.useState('BBA');
  const [location, setLocation] = React.useState('');
  const [position, setPosition] = React.useState('');
  const [date, setData] = React.useState('');
  const [openSnack, setOpenSnack] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [severity, setSeverity] = React.useState('');

  const [modalData, setmodalData] = React.useState([]);

  const handleModalData = (message, severity) => {
    handleSnack(message, severity)
  }

  const loading = open && companies.length === 0;

  const history = useHistory()

  const classes = useStyles();

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      const response = await getCompaniesAPIReq()
      const companies = await response
      // console.log(response);
      if (active) {
        setCompanies(Object.keys(companies).map((key) => companies[key]));
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setCompanies([]);
    }
  }, [open]);


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSnack = (message, severity) => {
    setOpenSnack(true);
    setMessage(message);
    setSeverity(severity);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const [openDialog, setOpenDialog] = React.useState(false);

  const successOffer = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = (history) => {
    setOpenDialog(false);
    history.push('/offers');
  };

  // var defDate = moment(today.setDate(today.getDate() + 7)).format('YYYY-MM-DD')

  let today = new Date();
  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      title: "",
      position: "",
      school: "SBA",
      targeted_major: "BBA",
      company: "",
      location: "",
      description: "",
      open_positions: 0,
      end_date: moment(today.setDate(today.getDate() + 7)).format('YYYY-MM-DD')
    },
    touched: {},
    errors: {}
  });


  const handleChange = (event) => {
    event.persist();

    if(event.target.value.match(/^[a-zA-Z0-9\s._èéêàá?!\[\]();,@#$%^&*:'"+~|<>-]*$/)) {
      setFormState(formState => ({
        ...formState,
        values: {
          ...formState.values,
          [event.target.name]:
            event.target.type === 'checkbox'
              ? event.target.checked
              : event.target.value
        },
        touched: {
          ...formState.touched,
          [event.target.name]: true
        }
      }));
    }
  };

  const schema = {
    title: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 50,
        message: "The title is too long"
      }
    },
    position: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 50,
        message: "The position is too long"
      }
    },
    school: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 100
      }
    },
    targeted_major: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 100
      }
    },
    company: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 100,
        message: "The company name is too long"
      }
    },
    location: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 100,
        message: "The location is too long"
      }
    },
    description: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 3000,
        message: "The description is too long"
      }
    },
    open_positions: {
      presence: { allowEmpty: false, message: 'is required' },
    },
    end_date: {
      presence: { allowEmpty: false, message: 'is required' },
    },

  };



  function handlePostClick(e) {
    e.preventDefault();

    return postOfferAPIReq(formState.values, history)
      .then(res=>{
        console.log(res)
        if (res.hashed_id) {
          successOffer()
        } else if (res.status === 'fail') {
          handleSnack("An error occurred: " + res.error.message, "error")
        }
      }).catch((err) => {
        // console.log('error')
        handleSnack("An error occurred ", "error")
      })
  }


  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <div>
      <Card>
        <form
          className={classes.form}
          onSubmit={handlePostClick}
        >
          <CardHeader
            subheader="Create your offer"
            title="Offer details"
          />
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  error={hasError('title')}
                  helperText={
                    hasError('title') ? formState.errors.title[0] : null
                  }
                  label="Offer Title"
                  margin="dense"
                  name="title"
                  onChange={handleChange}
                  required
                  value={formState.values.title || ''}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  error={hasError('position')}
                  helperText={
                    hasError('position') ? formState.errors.position[0] : null
                  }
                  label="Position or Department."
                  margin="dense"
                  name="position"
                  onChange={handleChange}
                  required
                  value={formState.values.position || ''}
                  variant="outlined"
                />
               
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  error={hasError('school')}
                  helperText={
                    hasError('school') ? formState.errors.school[0] : null
                  }
                  label="Select Targeted School"
                  margin="dense"
                  name="school"
                  onChange={handleChange}
                  required
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{ native: true }}
                  value={formState.values.school || ''}
                  variant="outlined"
                >
                  <option
                    key="SBA"
                    value="SBA"
                  >
                    SBA
                  </option>
                  <option
                    key="SHSS"
                    value="SHSS"
                  >
                    SHSS
                  </option>
                  <option
                    key="SSE"
                    value="SSE"
                  >
                    SSE
                  </option>
                </TextField>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  error={hasError('targeted_major')}
                  helperText={
                    hasError('targeted_major') ? formState.errors.targeted_major[0] : null
                  }
                  label="Select Targeted Major"
                  margin="dense"
                  name="targeted_major"
                  onChange={handleChange}
                  required
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{ native: true }}
                  value={formState.values.targeted_major || ''}
                  variant="outlined"
                >
                  {majors.map(option => (
                    <option
                      key={option.id}
                      value={option.code}
                    >
                      {option.major_name}
                    </option>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                <Autocomplete
                  getOptionLabel={(option) => option.name}
                  getOptionSelected={(option, value) => option.name === value.name}
                  id="asynchronous-demo"
                  loading={loading}
                  onChange={(event, newValue) => {
                    formState.values.company = newValue.name
                  }}
                  onClose={() => {
                    setOpen(false);
                  }}
                  onOpen={() => {
                    setOpen(true);
                  }}
                  open={open}
                  options={companies}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {loading ? <CircularProgress
                              color="inherit"
                              size={20}
                                       /> : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                      label="Choose a company (or create one)"
                    />
                  )}
                  style={{ width: '100%' }}
                  value={company}
                />

              </Grid>
              <Grid
                item
                md={2}
                xs={12}
              >
                <CreateCompany  handleModalData={handleModalData}/>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  error={hasError('location')}
                  helperText={
                    hasError('location') ? formState.errors.location[0] : null
                  }
                  label="Location (Ex: Agadir, Morocco)"
                  margin="dense"
                  name="location"
                  onChange={handleChange}
                  required
                  value={formState.values.location || ''}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                lg={12}
              >
                <Divider dark />
                <br />
                <TextField
                  defaultValue=""
                  fullWidth
                  error={hasError('description')}
                  helperText={
                    hasError('description') ? formState.errors.description[0] : null
                  }
                  helperText="Please specify the offer description"
                  label="Offer description"
                  margin="dense"
                  multiline="true"
                  rows={4}
                  name="description"
                  onChange={handleChange}
                  required
                  value={formState.values.description || ''}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                lg={6}
              >
                <TextField
                  fullWidth
                  error={hasError('open_positions')}
                  helperText={
                    hasError('open_positions') ? formState.errors.open_positions[0] : null
                  }
                  helperText="Please specify the number of open positions"
                  label="Number of open positions"
                  margin="dense"
                  name="open_positions"
                  onChange={handleChange}
                  required
                  type="number"
                  // value={formState.values.open_position || 0}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                lg={12}
              >
                <TextField
                  defaultValue={moment(today.setDate(today.getDate() + 7)).format('YYYY-MM-DD')}
                  error={hasError('end_date')}
                  helperText={
                    hasError('end_date') ? formState.errors.end_date[0] : null
                  }
                  id="date"
                  // label="Deadline for applications"
                  name="end_date"
                  type="date"
                  label="Deadline"
                  onChange={handleChange}
                  // value={formState.values.end_date}
                />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardActions >
            <Button
              color="primary"
              disabled={!formState.isValid}
              onClick={
                handlePostClick
              }
              type="submit"
              variant="contained"
            >
              Submit
            </Button>
          </CardActions>
        </form>
      </Card>
      <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
        <Alert onClose={handleCloseSnack} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Your offer has been created!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Alert severity="success">This offer has been created. It is now available! Thank you</Alert>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseDialog(history)} color="primary" autoFocus>
            Go back
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
